module.exports = __webpack_public_path__ + "static/media/slide1.7f980f24.jpg";